  /**
 * 资源中心分组
 */

 import {
    get,
    post,
    put,
    del
  } from '@/util/request'
  
  /**
   * 新增数据记录
   * @param {*} data
   * @returns
   */
   export const AddResourceGroup = (data) => {
    return post('/api/app/ResourceGroup', data, {});
   }

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
    export const ModifyResourceGroup = (data) => {
        return put('/api/app/ResourceGroup', data, {});
    }

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
    export const DeleteResourceGroup = (id) => {
        return del('/api/app/ResourceGroup/' + id, {}, {});
    }
/**
 * 根据id查询
 * @param {*} data
 * @returns
 */
    export const SelectResourceGroupByCode = (code) => {
        return get('/api/app/resourceGroup?id=' + code);
    }
    /**
 * 分页获取数据
 * @param {*} data
 * @returns
 */
    export const GetDataResourceGroupList = (data) => {
        return post('/api/app/resourceGroup/list', data, {});
    }